<nz-table [nzData]=" data$ | async" 
    [nzPageIndex]="pageIndex$ | async" 
    [nzPageSize]="pageSize$ | async" 
    [nzFrontPagination]="false" 
    [nzTotal]="totalCount$ | async" 
    nzShowQuickJumper
    nzShowSizeChanger
    nzBordered
    (nzPageSizeChange)="pageSizeChange($event)"
    (nzPageIndexChange)="onPageIndexChagne($event)" [nzShowTotal]="simple?undefined:rangeTemplate" [nzSimple]="simple" [nzScroll]="scroll?scroll:{}">
    <thead>
        <tr>
            <th *ngIf="detailTemplate" [nzWidth]="'40px'"></th>
            <th *ngFor="let col of columnList" [nzWidth]="col.width?col.width:'auto'">{{col.label}}</th>
            <th *ngIf="!simple" [nzWidth]="actionWidth?actionWidth+'px':'150px'" nzRight>{{'Common.Action' | translate }}</th>
            <th *ngIf="simple" [nzWidth]="actionWidth?actionWidth+'px':'40px'"></th>
        </tr>
    </thead>
    <tbody>
        <ng-container *ngFor="let item of tableData">
            <tr>
                <ng-container *ngIf="detailTemplate">
                    <td [nzExpand]="expandSet.has(getId(item))" (nzExpandChange)="onExpandChange(getId(item), $event)">

                    </td>
                </ng-container>

                <ng-container *ngFor="let col of columnList">
                    <ng-container [ngSwitch]="col.columnType">
                        <ng-container *ngSwitchCase="columnTypes.Image">
                            <td>
                                <div class="device-model-img" *ngIf="item[col.field]; else notImage">
                                    <!-- <img *ngIf="item[col.field]" [src]="item[col.field] | attachmentUrl" style="width:40px;height:40px;"> -->
                                    <mm-attachment-viewer
                                    [fileName]="item[col.field]"></mm-attachment-viewer>
                                </div>
                                <ng-template #notImage>
                                    <div class="device-model-img">
                                    </div>
                                </ng-template>
                            </td>
                        </ng-container>
                        <ng-container *ngSwitchCase="columnTypes.Date">
                            <td nzEllipsis nz-tooltip [nzTooltipTitle]="item[col.field] | date:'yyyy-MM-dd'" nzTooltipPlacement="topLeft">
                                <span>{{item[col.field] | date:'yyyy-MM-dd'}}</span>
                            </td>
                        </ng-container>
                        <ng-container *ngSwitchCase="columnTypes.DateTime">
                            <td nzEllipsis nz-tooltip [nzTooltipTitle]="item[col.field] | date:'yyyy-MM-dd HH:mm:ss'" nzTooltipPlacement="topLeft">
                                <span>{{item[col.field] | date:'yyyy-MM-dd HH:mm:ss'}}</span>
                            </td>
                        </ng-container>
                        <ng-container *ngSwitchCase="columnTypes.UserName">
                            <td nzEllipsis nz-tooltip [nzTooltipTitle]="item[col.field] | userName" nzTooltipPlacement="topLeft">
                                <span>{{item[col.field] | userName }}</span>
                            </td>
                        </ng-container>
                        <ng-container *ngSwitchCase="columnTypes.I18nString">
                            <td nzEllipsis nz-tooltip [nzTooltipTitle]="item[col.field] | localize" nzTooltipPlacement="topLeft">
                                <span>{{item[col.field] | localize }}</span>
                            </td>
                        </ng-container>
                        <ng-container *ngSwitchCase="columnTypes.EnumOptions">
                            <td nzEllipsis nz-tooltip [nzTooltipTitle]="col.options[item[col.field]] | localize" nzTooltipPlacement="topLeft">
                                <span>{{col.options[item[col.field]] | localize }}</span>
                            </td>
                        </ng-container>
                        <ng-container *ngSwitchCase="columnTypes.Boolean">
                            <td nzEllipsis nz-tooltip [nzTooltipTitle]="item[col.field]" nzTooltipPlacement="topLeft">
                                <span>{{item[col.field]|boolLabel|translate}}</span>
                            </td>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <td nzEllipsis nz-tooltip [nzTooltipTitle]="item[col.field]" nzTooltipPlacement="topLeft">
                                <span>{{item[col.field] }}</span>
                            </td>
                        </ng-container>
                    </ng-container>
                </ng-container>

                <td nzRight>
                    <ng-container *ngIf="actionTemplate;else defaultActions">
                        <ng-container *ngTemplateOutlet="actionTemplate;context:{ $implicit:item }"></ng-container>
                    </ng-container>
                    <ng-template #defaultActions>
                        <button (click)="this.editEmmiter.emit(item)" [authorize]="authorizeBase+'.OPERATE'" nz-button nzType="link" [nzTooltipTitle]="'Common.Edit' | translate" nz-tooltip>
                            <span>{{'Common.Edit' | translate}}</span>
                        </button>
                        <wx-delete-confirm-icon (confirm)="this.delEmmiter.emit(item)" [authorize]="authorizeBase+'.OPERATE'"></wx-delete-confirm-icon>
                    </ng-template>
                </td>
            </tr>
            <ng-container *ngIf="detailTemplate">
                <tr [nzExpand]="expandSet.has(getId(item))">
                    <ng-container *ngTemplateOutlet="detailTemplate;context:{ $implicit:item }"></ng-container>
                </tr>
            </ng-container>

        </ng-container>
    </tbody>
</nz-table>
<ng-template #rangeTemplate let-total> {{'Common.Total' | translate}} {{ total }}
    {{isPlural(total, 'Common.Item') | translate }} </ng-template>